<template>
    <div>
        <!--Header-->
        <div class="mt-4 flex justify-between items-center select-none">
            <h1 v-if="mutableLeases && mutableLeases.length > 0" class="text-2xl font-light text-gray-400">Leases synced from Rams</h1>
        </div>

        <!--Tickets Table-->
        <div v-if="mutableLeases && mutableLeases.length > 0" class="flow-root">
            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle px-6 lg:px-8">
                    <div class="overflow-hidden shadow rounded-md">
                        <table ref="ticketsTable" class="min-w-full divide-y divide-gray-300" :style="{ height: tableHeight + 'px' }">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="py-2 px-4 text-left text-sm font-medium text-gray-900">
                                        <div class="text-gray-900 font-medium">Lease Dates</div>
                                        <div class="text-indigo-600 font-medium">
                                            <span>Contacts</span>
                                            <span v-if="currentTailwindBreakpoint < 2"
                                                  class="border border-gray-300 rounded-md bg-gray-100 text-gray-900 text-xs px-1">
                                                Wallet
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-3 py-2 text-left text-sm font-medium text-gray-900 hidden md:table-cell">
                                        <div class="font-medium">Wallet Reference</div>
                                    </th>
                                    <th scope="col" class="px-3 py-2 text-right text-sm font-normal text-gray-900">
                                        <div class="font-medium">Rent</div>
                                        <div v-if="currentTailwindBreakpoint < 2" class="font-medium text-indigo-600">Deposit</div>
                                    </th>
                                    <th v-if="currentTailwindBreakpoint >= 2"
                                        scope="col" class="px-3 py-2 text-right text-sm font-medium text-gray-900">
                                        Deposit Balance
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white" ref="rowDropdownMenuAnchor">
                                <lease-list-row-for-asset v-for="lease in mutableLeases" :lease="lease" :key="lease.id"></lease-list-row-for-asset>

                                <tr v-if="mutableLeases" v-for="i in emptyRows" :key="'empty-' + i" class="invisible">
                                    <td class="py-2 text-white">
                                        <!--This is to match the height of a typical row for the table height management to calculate correctly-->
                                        <span class="invisible block">Placeholder</span>
                                        <span class="invisible block">Placeholder</span>
                                    </td>
                                    <td class="py-2 text-white"></td>
                                    <td class="py-2 text-white"></td>
                                    <td class="py-2 text-white"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center">
                            <plain-pagination
                                v-if="mutableLeases && (paginationData.next_page_url || paginationData.prev_page_url)"
                                :meta="paginationData"
                                padding="2"
                                @page-changed="fetchLeases">
                            </plain-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="!isLoadingLeases" class="mt-8 select-none text-center flex items-center justify-center text-light text-3xl text-gray-400">
            <div class="flex flex-col items-center">
                <div v-if="hasFeature('feat_leases') && mutableLeases.length == 0">No leases synced yet</div>

                <div v-else class="tex-center text-lg text-brand w-full">
                    <div class="flex w-full justify-center mt-8">
                        <img class="w-50" src="/images/weconnectu-logo-tm.png" alt="weconnectu-logo-2025.png">
                    </div>
                    <div class="mt-6">
                        Contact Support to find out more about our WeconnectU
                        <a href="https://www.weconnectu.co.za/rental-asset-management" class="underline text-indigo-600 hover:text-red-600">Rental Asset Management
                            Software</a>
                        integration.
                    </div>
                </div>

            </div>
        </div>

        <div v-else class="flex items-center justify-center">
            <loading-indicator></loading-indicator>
        </div>
    </div>
</template>

<script>
import PlainPagination from "../library/PlainPagination.vue";
import TableHeightManagementMixin from "../../mixins/table-height-management-mixin";
import SimplePaginatorMixin from "../../mixins/simple-paginator-mixin";
import LeaseListRowForAsset from "./LeaseListRowForAsset.vue";

export default {
    name: "lease-list-for-asset",
    components: {LeaseListRowForAsset, PlainPagination},
    mixins: [TableHeightManagementMixin, SimplePaginatorMixin],
    props: ["assetId"],
    data () {
        return {
            mutableLeases: [],
            isLoadingLeases: false,
        };
    },
    mounted () {
        this.fetchLeases();
    },
    methods: {
        fetchLeases (paginationSettings = null) {
            this.isLoadingLeases = true;

            let page = 1;
            let perPage = 5;

            if (paginationSettings) {
                page = new URL(paginationSettings).searchParams.get("page");
            }

            axios.get(`/contact-groups/asset/${this.assetId}/leases`, {
                params: {
                    page: page,
                    per_page: perPage,
                }
            }).then(response => {
                this.mutableLeases = response.data.data;
                this.setPaginatorData(response.data);
                this.setMaxItemsPreviouslyLoaded();
            }).catch(errors => {
                toastr.error("Error retrieving leases for asset.");
            }).finally(() => {
                this.isLoadingLeases = false;
            });
        },
    }
};

</script>


<style scoped>

</style>
